import * as Types from '../generated/types';

import { gql } from '@apollo/client';
export type ProposalNodeFragment = { __typename?: 'ProposalNode', id: string, currency: Types.DealsProposalCurrencyChoices, creationTime?: any | null, updateTime?: any | null, modelYear?: number | null, freeKmPerYear?: number | null, monthlyPayment?: number | null, deposit?: number | null, carPrice?: number | null, servicePrice?: number | null, totalPrice?: number | null, baseIndex?: number | null, participationFee?: number | null, residualPrice?: number | null, trackingMonthlyRate?: number | null, comprehensiveInsurancePrice?: number | null, comprehensiveInsuranceYoungPrice?: number | null, compulsoryInsurancePrice?: number | null, licencePrice?: number | null, leaseDuration: number, dealTypeString?: string | null, notes?: string | null, isOperational: boolean, hasDeal?: boolean | null, isLocked: boolean, taxLevel?: number | null, validFrom?: any | null, validTo?: any | null, customer?: { __typename?: 'CustomerNode', id: string, email?: string | null, name: string, type: Types.CustomersCustomerTypeChoices, title?: Types.CustomersCustomerTitleChoices | null, shouldUnionInvoices: boolean } | null, carSubModel?: { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null, brand: { __typename?: 'BrandNode', id: string, name: string } } } | null, installations: { __typename?: 'InstallationNodeConnection', edges: Array<{ __typename?: 'InstallationNodeEdge', node?: { __typename?: 'InstallationNode', id: string, name: string, priceWithoutVat: any, installationType: Types.DealsInstallationInstallationTypeChoices, isCustomerPaid: boolean } | null } | null> } };

export const ProposalNodeFragmentDoc = gql`
    fragment ProposalNode on ProposalNode {
  id
  currency
  creationTime
  updateTime
  modelYear
  freeKmPerYear
  monthlyPayment
  deposit
  carPrice
  servicePrice
  totalPrice
  baseIndex
  participationFee
  residualPrice
  trackingMonthlyRate
  comprehensiveInsurancePrice
  comprehensiveInsuranceYoungPrice
  compulsoryInsurancePrice
  licencePrice
  leaseDuration
  dealTypeString
  customer {
    id
    email
    name
    type
    title
    shouldUnionInvoices
  }
  carSubModel {
    id
    name
    localName
    carModel {
      id
      name
      localName
      brand {
        id
        name
      }
    }
  }
  installations {
    edges {
      node {
        id
        name
        priceWithoutVat
        installationType
        isCustomerPaid
      }
    }
  }
  notes
  isOperational
  hasDeal
  isLocked
  taxLevel
  validFrom
  validTo
}
    `;